import DashboardTargetsFiltersMobile from './DashboardTargetsFiltersMobile';

export default DashboardTargetsFiltersMobile;
